import styled from 'styled-components';

import { Flex } from 'src/kit';

export const CenteredFlex = styled(Flex)`
  align-content: center;
  justify-content: center;
  align-items: center;
  justify-items: center;
`;
